import React, { useEffect, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PageTitleContainer from '../common/PageTitleContainer';
import HeaderSection from './HeaderSection';
import TablePagination from '@mui/material/TablePagination';
import { findAllTeams, deleteTeam, findAllTeamGroups } from '../../redux';
import CustomDialog from '../ui/CustomDialog';
import DeleteConfirmDialog from '../ui/DeleteConfirmDialog';
import ViewDetails from './ViewDetails';
import EditForm from './EditForm';
import LogoForm from './LogoForm';
import { GetTcolumns, GetTsearch, GetTvalues } from './TableData';
import SortTable from '../common/SortTable';
import ToggleTableTrash from '../common/ToggleTableTrash';

const initialStateFilter = {
  deleted: false,
  page: 0,
  pagesize: 10,
  sort: 'teams.teamName',
  direction: 'ASC',
  teamName: '',
  active: '',
  groupId: '',
}

const initialStateOther = {
  pageLoaded: false,
  modalDiaLogTitle: '',
  modalDiaLogId: false,
  openDelete: false,
  openView: false,
  openEdit: false,
  openLogo: false
}

const reducerFilter = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const TeamContainer = (props) => {

  const [state, updateState] = useReducer(reducerFilter, initialStateFilter);
  const [state2, updateState2] = useReducer(reducerFilter, initialStateOther);
  const ui = useSelector((state) => state.ui);
  const team = useSelector((state) => state.team);
  const teamGroup = useSelector((state) => state.teamGroup);
  const dispatch = useDispatch();

  const setOpen = (open, modalDiaLogId=false, modalDiaLogTitle='', modalName=null) => {
    updateState2({ modalDiaLogId: modalDiaLogId });
    updateState2({ modalDiaLogTitle: modalDiaLogTitle });

    if(modalName !== null) {
      if(modalName === 'VIEW') {
        updateState2({ openView: open });
      } else if(modalName === 'EDIT') {
        updateState2({ openEdit: open });
      } else if(modalName === 'DELETE') {
        updateState2({ openDelete: open });
      } else if(modalName === 'LOGO') {
        updateState2({ openLogo: open })
      }
    } else {
      updateState2({ openView: false });
      updateState2({ openEdit: false });
      updateState2({ openDelete: false });
      updateState2({ openLogo: false });
    }

  }
  const _deleteTeam = (modalDiaLogId) => {
    dispatch(deleteTeam(modalDiaLogId, state));
  }
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    updateState({ [name]: value });

    /* on Selection */
    if(['active','sort','direction','deleted','groupId'].includes(name)) {
      updateState({ page: 0 });
      let newFilters = state;
      newFilters[name] = value;
      newFilters['page'] = 0;
      dispatch(findAllTeams(newFilters));
    }

  }
  const handleTableChangePage = (event, newPage) => {
    dispatch(findAllTeams({...state, page: newPage }));
    updateState({ page: newPage });
  }
  const handleTableChangeRowsPerPage = (event) => {
    dispatch(findAllTeams({...state, page: 0, pagesize: parseInt(event.target.value, 10) }));
    updateState({ page: 0, pagesize: parseInt(event.target.value, 10) });
  }
  const onSearchInputEnterKey = () => {
    dispatch(findAllTeams({...state, page: 0}));
    updateState({ page: 0 });
  }
  const resetTableSearchInput = () => {
    updateState2({ pageLoaded: false });
  }

  useEffect(() => {
    if(!state2.pageLoaded) {
      updateState(initialStateFilter);
      updateState2({ pageLoaded: true });
      dispatch(findAllTeamGroups({ active:1, pagesize:1000, sort:'groupName', direction:'ASC' }));
      dispatch(findAllTeams(initialStateFilter));
    }
  }, [state2, dispatch]);


  /*** table columns ***/
  const t_data = team.data;
  const t_pagination = team.pagination;

  /*** table fields ***/
  const t_columns = <GetTcolumns openGlobalLoader={ui.openGlobalLoader}/>

  /*** table search ***/
  const t_search = <GetTsearch
    onSearchInputEnterKey={onSearchInputEnterKey}
    handleInputChange={handleInputChange}
    teamGroup={teamGroup}
    resetTableSearchInput={resetTableSearchInput}
    teamName={state.teamName}
    active={state.active}
    groupId={state.groupId}
    />

  /*** table data ***/
  const t_values = <GetTvalues t_data={t_data}
    setOpen={setOpen}
    deleted={state.deleted}
    t_index={state.page * state.pagesize}
    />

  return (
    <main id="main" className="main">
      <PageTitleContainer pageTitle={props.pageTitle} >
        <HeaderSection
          teamGroup={teamGroup}
          filterInput={state}
          />
      </PageTitleContainer>
      <section className="section">
        <div className="row">

          <CustomDialog title={`View Team ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`} open={state2.openView} setOpen={setOpen} >
            <ViewDetails
              modalDiaLogId={state2.modalDiaLogId}
              setOpen={setOpen}
            />
          </CustomDialog>

          <CustomDialog maxWidth="sm" title={`Update Team ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`} open={state2.openEdit} setOpen={setOpen} >
            <EditForm
              teamGroup={teamGroup}
              modalDiaLogId={state2.modalDiaLogId}
              setOpen={setOpen}
              filterInput={state}
            />
          </CustomDialog>

          <DeleteConfirmDialog
              title={`${ state.deleted ? 'Restore': 'Delete' } Team ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`}
              modalDiaLogId={state2.modalDiaLogId}
              open={state2.openDelete}
              setOpen={setOpen}
              onConfirm={_deleteTeam}
              >
            Are you sure you want to { state.deleted ? 'Restore': 'Delete' } team <strong className="p-2"> {state2.modalDiaLogTitle} </strong> ?
          </DeleteConfirmDialog>

          <CustomDialog maxWidth="sm" title={`Upload Logo ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`} open={state2.openLogo} setOpen={setOpen} >
            <LogoForm
              modalDiaLogId={state2.modalDiaLogId}
              setOpen={setOpen}
            />
          </CustomDialog>

        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">


                <div className="row mb-1">
                  <div className="col col-sm-9">
                    <div className="float-start">
                      <SortTable sortName={'team'}
                        sort={state.sort}
                        direction={state.direction}
                        handleInputChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="float-end">
                      <ToggleTableTrash
                        deleted={state.deleted}
                        handleInputChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover table-sm">
                    <thead>{ t_columns }</thead>
                    <tbody>
                      { t_search }
                      { t_values }
                    </tbody>
                  </table>
                </div>

                <TablePagination
                  component="div"
                  count={t_pagination.itemcount}
                  page={state.page}
                  onPageChange={handleTableChangePage}
                  rowsPerPage={state.pagesize}
                  onRowsPerPageChange={handleTableChangeRowsPerPage}
                  showFirstButton={true}
                  showLastButton={true} />

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )

}

export default TeamContainer;
